<!--
 Filter Container Computer
 Show facets and handle filter communication for computer devices.
 devs@droxit.de
 Copyright (c) 2022 droxIT GmbH
-->

<template>
  <b-container fluid="md" id="rocketsearch-facets-container">
    <CategoryFacetComputer
      :facet=category_facet
      :filter=filters[category_facet.name]
      :key=getKey(category_facet)
      style="margin-bottom: 16px;"
    />
    <div class="header-cell border-header">
      <b-row class="rocketsearch-column-header-text">
        <span>{{$t('filters_label')}}</span>
      </b-row>
    </div>
    <div v-for="facet in non_category_facets" :key="facet.name" style="width: 100%;margin-bottom: 16px;">
      <TermsFacetComputer
        v-if="facet.type=='terms'"
        :facet=facet
        :filter=filters[facet.name]
        :key=getKey(facet)
      />
      <RangeSliderComputer
        v-if="facet.type=='range'"
        :facet=facet
        :filter=filters[facet.name]
        :key=getKey(facet)
      />
    </div>
  </b-container>
</template>

<script>
  import CategoryFacetComputer from "./Facets/CategoryFacetComputer.vue";
  import TermsFacetComputer from "./Facets/TermsFacetComputer.vue";
  import RangeSliderComputer from "./Facets/RangeSliderComputer.vue";

  /*
  * The Result Container, showing preview or all results for a search term
  */
  export default {
    name: 'FacetsContainerComputer',
    props: {
      facets: Array,
      filters: Object
    },
    components: {
      CategoryFacetComputer,
      TermsFacetComputer,
      RangeSliderComputer
    },
    mounted() {
      this.prepare_facets();
    },
    watch: {
      facets: function() {
        this.prepare_facets();
      }
    },
    data() {
      return {
        category_facet: {},
        non_category_facets: []
      }
    },
    methods: {
      prepare_facets() {
        if(!this.facets){
          return;
        }

        var category_facet = {};
        var non_category_facets = [];

        this.facets.forEach(
          function(facet) {
            if (facet.name == "category") {
              category_facet = facet;
            } else {
              if(facet.type == "terms") {
                non_category_facets.push(facet);
              } else {
                non_category_facets.push(facet);
              }
            }
          }
        );

        this.category_facet = category_facet;
        this.non_category_facets = non_category_facets;
      },
      getKey(facet){
          if(facet.type=="terms"){
            return facet.options.map(x => x.value + ":" + x.num).reduce((acc, curr) => acc + curr, "");
          }
          if(facet.type=="range"){
            return facet.from + "-" + facet.to;
          }
        return 0;
      }
    }
  }
</script>